import styled from 'styled-components';
import ds, { media } from 'designsystem';

const Image = styled.img`
  position: relative;
  object-fit: contain;
  max-height: 300px;
  z-index: 1;
  margin-left: auto;
  margin-right: auto;
  top: ${ds.get('metrics.m')};
  
  ${media.mobile`
    max-height: 450px;
  `}

  ${media.tablet`
    max-height: 600px;
    top: ${ds.get('metrics.l')};
  `}

  ${media.desktop`
    left: ${ds.get('metrics.base')};
    max-height: 727px;
    position: absolute;
  `};
`;

export default Image;



// WEBPACK FOOTER //
// ./src/kentico-blocks/LinkBanner/Image.jsx